/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import gql from 'graphql-tag';

import { Params } from 'react-router-dom';
import s from './ProfessionDetailScreen.module.scss';
import AppContext, { AppContextType } from '../../context';
import Loading from '../Loading';
import { withRouter } from '../../util/withRouter';
import NotFound from '../../routes/notFound';
import { JOBS_VERSION } from '../../constants/professions';

const professionQuery = gql`
  query profession($title: String!) {
    profession(title: $title) {
      key
      title
      imageName
      description
      education
    }
  }
`;

interface ProfessionDetailScreenProps {
  params: Readonly<Params<string>>;
}

class ProfessionDetailScreen extends React.Component<ProfessionDetailScreenProps> {
  static contextType = AppContext;

  // eslint-disable-next-line react/state-in-constructor
  state: any;

  constructor(props: any) {
    super(props);

    this.state = {
      loading: true,
      profession: null,
    };

    this.fetchProfession = this.fetchProfession.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  componentDidMount(): void {
    this.fetchProfession();
  }

  async fetchProfession() {
    try {
      const result = await (this.context as AppContextType).client.query({
        query: professionQuery,
        variables: {
          title: this.props.params.id,
        },
        fetchPolicy: 'network-only',
      });

      if (result.data.profession != null) {
        this.setState({
          loading: false,
          profession: {
            ...result.data.profession,
            imageName: `https://www.jopsy.at/appimages/jobs/${JOBS_VERSION}/${result.data.profession.imageName}`,
          },
        });
      } else {
        this.setState({ loading: false });
      }
    } catch (e: any) {
      this.setState({ loading: false });
      // do nothing
    }
  }

  renderContent() {
    const { profession } = this.state;

    return (
      <div className={s.contentContainer}>
        <div className={s.titleContainer}>
          <h1 className={s.title}>{profession.title}</h1>
        </div>
        <div className={s.imageAndContent}>
          <img src={profession.imageName} alt={profession.title} />
          <div className={s.descriptionAndEducation}>
            <div>{profession.description}</div>
            <div>
              <h2>Mögliche Ausbildungswege:</h2>
              <ul>
                {profession.education.map((key: string) => (
                  <li className={s.educationItem} key={key}>
                    {key}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { profession, loading } = this.state;

    if (!loading && profession == null) {
      return <NotFound />;
    }

    return (
      <>
        <div className={s.professionDetailScreenContainer} data-nosnippet>
          {!loading && this.renderContent()}
        </div>
        {this.state.loading && <Loading />}
      </>
    );
  }
}

export default withRouter(ProfessionDetailScreen);
